import React from "react";
import { Wrap } from "@chakra-ui/react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DraggableCustomization from "./DraggableCustomization";

const CustomizationList = ({
  customizations,
  setCustomizations,
  onCustomizationClick,
  handleRemoveCustomization,
}) => {
  const moveCustomization = (fromIndex, toIndex) => {
    const updatedCustomizations = [...customizations];
    const [movedCustomization] = updatedCustomizations.splice(fromIndex, 1);
    updatedCustomizations.splice(toIndex, 0, movedCustomization);

    const reorderedCustomizations = updatedCustomizations.map((customization, index) => ({
      ...customization,
      sequence_number: index,
    }));

    setCustomizations(reorderedCustomizations);
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Wrap spacing={2}>
        {customizations.map((customization, index) => (
          <DraggableCustomization
            key={customization.id}
            customization={customization}
            index={index}
            moveCustomization={moveCustomization}
            onCustomizationClick={onCustomizationClick}
            handleRemoveCustomization={handleRemoveCustomization}
          />
        ))}
      </Wrap>
    </DndProvider>
  );
};

export default CustomizationList; 